import { useCallback, useMemo } from "react";
import { useGetValueByCode } from "./useGetValueByCode";

export const useTransactionAmounts = (data: any) => {
  const { getValueByCode } = useGetValueByCode();

  const setData = useCallback(
    (map: any, code: string, prop: string, range: number) => {
      let finalCode: string = code;

      if (range === 1) {
        finalCode += "Today";
      } else if (range === 2) {
        finalCode += "ThisMonth";
      } else {
        finalCode += "ThisYear";
      }

      const val = getValueByCode(data.kpiValues, finalCode);

      if (val) {
        map[range][prop] = val.value;
      }
    },
    [data, getValueByCode],
  );

  const amounts = useMemo(() => {
    if (data) {
      const map: any = {
        1: {},
        2: {},
        3: {},
      };

      [1, 2, 3].forEach((item: number) => {
        setData(map, "Payments.Amounts.Count", "payments", item);

        setData(map, "Disbursements.Amounts.Count", "disbursements", item);
      });

      return map;
    }

    return null;
  }, [data, setData]);

  return { amounts };
};
